import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import './charges_card.scss';

function ChargesCard({ name, onEdit, onDelete }) {
  return (
    <Card className="charge-item-card" variant="outlined">
      <CardContent>
        <Typography variant="h6" component="h2">
          {name}
        </Typography>
        <div className="button-container">
          <IconButton onClick={onEdit} aria-label="edit" className="edit-button">
            <EditIcon />
          </IconButton>
          <IconButton onClick={onDelete} aria-label="delete" className="delete-button">
            <DeleteIcon />
          </IconButton>
        </div>
      </CardContent>
    </Card>
  );
}

export default ChargesCard;
